export const useApiLoading = () => {
  const pendingRequestCount = useState("global-api-pending-count", () => 0)

  const isLoading = computed(() => pendingRequestCount.value > 0)

  const startRequest = () => {
    pendingRequestCount.value += 1
  }

  const finishRequest = () => {
    pendingRequestCount.value = Math.max(0, pendingRequestCount.value - 1)
  }

  return { pendingRequestCount, isLoading, startRequest, finishRequest }
}
